import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { SearchBackDrop } from "../../component/common/SearchBackDrop";
import CustomPagination from "../../component/common/CustomPagination";
import EvalJsonDialog from "../EvalJsonDialog";
import EvalTextViewPage from "../EvalTextViewPage";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvknRSimpleQAPage = (props: any) => {

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [evkn_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [evknWorkList, setEvknWorkList] = useState([]);

  const [isp_yn, setIsp_yn] = useState('모두');

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const updateEvknRSimpleQA = async (isp: any) => {

    setBackdrop(true)
    
    const formData = new FormData();

    formData.append("email", email);

    formData.append("worker", worker);

    formData.append("isp_yn", ((isp === "일반상식" || isp === "기타") ? "Y" : isp));

    // if(isp === "일반상식") formData.append("new_category_cd", "201");

    const updatedColEvknData = {
      ...evknRSimpleQAData,
      reason_path: Array.isArray(reason_path) ? reason_path : (() => {
        try { return JSON.parse(reason_path as string); } catch { return []; }
      })(),
      isp_yn: isp,
      category_cd: (isp === "일반상식" ? "201" : (isp === "기타" ? "206" : evknRSimpleQAData.category_cd)),
    };

    formData.append("evknRSimpleQAData", JSON.stringify(updatedColEvknData));

    await api.post("/updateEvknRSimpleQA",formData)
    .then((res:any) => {alert(updatedColEvknData.source_id + " 데이터 검수 완료"); setBackdrop(false); getEvknDataList(true);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const [evknRSimpleQAData, setEvknRSimpleQAData] = useState<any>([]);

  const [reason_path, setReason_path] = useState<any>([]);

  const reason_path_change = (idx: number, val: string) => {
    setReason_path((prev:any) => {
      const next = [...prev];
      next[idx] = val;
      return next;
    });
  };

  const handleAdd = () => setReason_path((prev) => [...prev, ""]);
  const handleRemove = (idx: number) =>
    setReason_path((prev) => prev.filter((_, i) => i !== idx));

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getEvknDataList = async (selectFirst: boolean = false) => {
    
    setBackdrop(true)
    api.get('/evknDataList',{params:{email:email, worker:worker, page:page, order:order, isp_yn:isp_yn, idx:""}})
    .then((res:any) => {
      
      

      if(res.data.datas.length > 0){
        setEvknWorkList(res.data.datas);
        

        if (selectFirst) {
          // 호출 시 명시적으로 첫 번째 row 선택
          setEvknRSimpleQAData(res.data.datas[0]);
          setReason_path(JSON.parse(res.data.datas[0].reason_path));
        }else if((evknRSimpleQAData && evknRSimpleQAData.idx == -1) || (pagination && page != pagination.current_page)){
          setEvknRSimpleQAData(res.data.datas[0])
        }
        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        setEvknWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  useEffect(() => {
    getEvknDataList()
  }, [page, props.rowDetail]);
  
  useEffect(() => {
      const handleKeyDown = (e: KeyboardEvent) => {
        // 입력 중일 때(텍스트 필드/텍스트에어리어 등)에는 핫키 동작 막기
        const target = e.target as HTMLElement;
        if (target) {
          const tagName = target.tagName;
          if (tagName === "INPUT" || tagName === "TEXTAREA" || (target as any).isContentEditable) {
            return;
          }
        }
  
        if (e.key === "1") {
          e.preventDefault();
          updateEvknRSimpleQA("Y");
        } else if (e.key === "0") {
          e.preventDefault();
          updateEvknRSimpleQA("P");
        } else if (e.key === "7") {
          e.preventDefault();
          updateEvknRSimpleQA("일반상식");
        } else if (e.key === "9") {
          e.preventDefault();
          updateEvknRSimpleQA("기타");
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [evknRSimpleQAData]); // 현재 선택된 row 정보에 맞게 동작하도록 colEvknData 의존

  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>지식 - 데이터 검수(최종)</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

        <EvalTextViewPage sid={evknRSimpleQAData.source_id} />

        {/* simpleQA */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#e4ffdc"}}>
              <Box sx={{margin:"4px"}}>
                <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                  <Box>
                    <Box display="flex" justifyContent="center">
                      <Box sx={{fontSize:"20px", fontWeight:700, textAlign:"center", margin:"2px"}}>EVKN_RSimpleQA</Box>
                      <Button variant="contained" size="small" sx={{marginLeft:"32px",fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                        OPEN JSON
                      </Button>
                    </Box>
                    {openJsonDialog ? <EvalJsonDialog className="json-dialog-content" data={evknRSimpleQAData.prc_json} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
                    
                    <Box display="flex" sx={{marginTop:"8px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류</Box>
                      <Select id="topic_cd" value={evknRSimpleQAData?.category_cd || ""} onChange={(e) => {setEvknRSimpleQAData({ ...evknRSimpleQAData, category_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"340px", height: "28px", marginLeft: "54px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={""}>선택하세요</MenuItem>
                        <MenuItem dense value={"101"}>한국형-역사</MenuItem>
                        <MenuItem dense value={"102"}>한국형-문화</MenuItem>
                        <MenuItem dense value={"103"}>한국형-사회</MenuItem>
                        <MenuItem dense value={"104"}>한국형-지리</MenuItem>
                        <MenuItem dense value={"105"}>한국형-언어</MenuItem>
                        <MenuItem dense value={"106"}>한국형-정치및법</MenuItem>
                        <MenuItem dense value={"201"}>글로벌-일반상식</MenuItem>
                        <MenuItem dense value={"202"}>글로벌-과학</MenuItem>
                        <MenuItem dense value={"203"}>글로벌-인문학및사회학</MenuItem>
                        <MenuItem dense value={"204"}>글로벌-공학및기술</MenuItem>
                        <MenuItem dense value={"205"}>글로벌-경제</MenuItem>
                        <MenuItem dense value={"206"}>글로벌-기타</MenuItem>
                      </Select>
                    </Box>
                    <Box sx={{margin:"0px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question (난이도 : <b style={{fontSize:"14px", fontWeight:700, textAlign:"center", margin:"2px", color:(evknRSimpleQAData.difficulty === "H" ? "red":(evknRSimpleQAData.difficulty === "M" ? "#d7c200": "#00db45")) }}>{(evknRSimpleQAData.difficulty === "H" ? "High":(evknRSimpleQAData.difficulty === "M" ? "Medium": "Low"))}</b>)</Box>
                    <Box><textarea spellCheck="false" value={evknRSimpleQAData.question || ""} onChange={(e) => {setEvknRSimpleQAData({ ...evknRSimpleQAData, question: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"140px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea spellCheck="false" value={evknRSimpleQAData.answer || ""} onChange={(e) => {setEvknRSimpleQAData({ ...evknRSimpleQAData, answer: e.target.value });}} style={{border:"4px solid #000", width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"8px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>QA_type</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box><textarea readOnly={true} spellCheck="false" value={evknRSimpleQAData.qa_type || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px"}}>
                <Box sx={{margin:"2px 0px 0px 12px", color:"#4664b4", fontWeight:700}}>Answer_type</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box>
                      <Select id="answer_type" value={evknRSimpleQAData.answer_type || ""} onChange={(e) => {setEvknRSimpleQAData({ ...evknRSimpleQAData, answer_type: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"620px", height: "28px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                        <MenuItem dense value={"Number"}>Number</MenuItem>
                        <MenuItem dense value={"Person"}>Person</MenuItem>
                        <MenuItem dense value={"Place"}>Place</MenuItem>
                        <MenuItem dense value={"Date"}>Date</MenuItem>
                        <MenuItem dense value={"Other"}>Other</MenuItem>
                      </Select>
                    </Box>
                      {/* <textarea readOnly={true} spellCheck="false" value={evknRSimpleQAData.answer_type || ""} style={{width:"620px",minHeight:"20px", fontSize:"16px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR" }}  /></Box> */}
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"100%", marginTop: "16px"}}>
                <Paper sx={{padding:"4px", border:"3px solid #3e36a5", backgroundColor:"#fff9c1"}}>
                  <Box sx={{margin:"4px 4px 4px 4px"}}>
                    <Box sx={{justifyContent: "center", display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px", width:"420px"}}>
                        <Box sx={{fontSize:"24px", fontWeight:700, textAlign:"center", margin:"2px"}}>추론경로(CoT)</Box>
                      </Box>
                      <Box><Button sx={{backgroundColor:"#9169ff"}} variant="contained" onClick={handleAdd}>항목 추가</Button></Box>
                    </Box>
                  </Box>
  
                  <Box sx={{width:"750px",margin:"4px", height:"200px", overflow:"auto"}}>
                    <Box sx={{margin:"4px 0px 4px 2px", color:"#4664b4", fontWeight:700}}>Reason Path ({reason_path && reason_path.length})</Box>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"8px", alignItems:"center"}}>
                        {reason_path && reason_path.map((item:any, index:any) => 
                          <Box key={"Box"+index} sx={{display:"flex", margin:"8px 0px 0px 2px", fontWeight:700}}>
                            <Box sx={{ width: "28px", fontWeight: 700, lineHeight: "28px" }}>{index + 1}.</Box>
                            <textarea key={index} spellCheck="false" value={item || ""}  onChange={(e) => reason_path_change(index, e.target.value)} style={{width:"640px",minHeight:"20px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  />
                            <DangerousRoundedIcon sx={{marginLeft:"8px"}} onClick={() => handleRemove(index)}>✕</DangerousRoundedIcon>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  
                  <Box display="flex">
                    {/* <Box sx={{display:"flex", marginTop:"16px"}}>
                      <Box sx={{display:"flex",marginLeft:"4px"}}>
                        <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                        <Box><textarea value={(evknRSimpleQAData.des === "None" ? "" : evknRSimpleQAData.des) || ""} onChange={(e) => {setEvknRSimpleQAData({ ...evknRSimpleQAData, des: e.target.value });}} style={{width:"360px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                      </Box>
                    </Box> */}
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="primary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateEvknRSimpleQA('Y');
                            }}
                          >
                            O (선정)
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={{width:"100%", marginTop: "8px"}}>
                        <Box display="flex" justifyContent="center">
                          <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"140px",height:"60px"}}
                            onClick={() => {
                              updateEvknRSimpleQA('P');
                            }}
                          >
                            X
                          </Button>
                        </Box>
                      </Box>
                  </Box>
                  
                </Paper>
              </Box>
              
            </Paper>
          </Box>
        </Box>
        {/* simpleQA */}

        {/* 작업 리스트 */}
        <Box>
        {/* Task 단위 화면 */}
        <Box display="flex" justifyContent="center" >
          <Box sx={{padding:"4px 8px 8px 8px", width:"368px"}}>
            <Box display="flex">
              <Box><img style={{width:"24px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} /></Box>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "16px", letterSpacing:"-2px"}}>작업목록</Box>
            </Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>검수</Box></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {(evknWorkList != undefined && evknWorkList.length > 0) ? evknWorkList.map((row:any, index:number) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(evknRSimpleQAData != undefined && row.idx === evknRSimpleQAData.idx ? "#dbdbef": "#fff")}}
                    onClick={()=> {setEvknRSimpleQAData(row); setReason_path(JSON.parse(row.reason_path));}}
                  >
                    <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                    <TableCell component="th" scope="row" align="center">
                      <Box sx={{width:"38px",fontSize:"12px", marginLeft:"8px", padding: "1px 3px 1px 3px", borderRadius:"4px",
                          border: (row.isp_yn === "Y" ? "2px solid #27cc2f" : (row.isp_yn === "P" ? "2px solid #7427cc" : "#000")), color:"#000" }}>
                        {(row.isp_yn === "Y" ? "완료" : (row.isp_yn === "P" ? "X" : "미작업"))}
                      </Box>
                    </TableCell>
                  </TableRow>
                  )):<TableRow><TableCell colSpan={2} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{marginTop:"12px"}}>
              {pagination !== undefined ? (
                  <>
                  <CustomPagination pagination={pagination} goPage={goPage} />
                  <Box display="flex">
                  <TextField size="small" id="worker" value={c_page} onChange={(e)=>setC_page(e.target.value)} 
                    sx={{width:"60px",height: "23px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} 
                    InputProps={{
                      style: {width: "60px", height:"23px", fontSize:"12px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                    />
                    <Button variant="contained" sx={{marginLeft:"8px",minWidth: "58px", height:"30px", fontSize:"12px"}} onClick={()=>setPage(Number(c_page))}>
                      이동
                    </Button>
                  </Box>
                  </>
              ) : ""}
            </Box>
          </Box>
          
          
        </Box>
      </Box>
            
      </Box>

    </Paper>
  );
  
  
};

export default EvknRSimpleQAPage;
